import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './styles.css';
import UofTLogo from './img/UofT-logo-blue.svg';

const MyModal = ({ show, onHide, time }) => (
  <Modal
    show={show}
    onHide={onHide}
    bsSize="lg"
    aria-labelledby="emergency-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title id="emergency-modal">Close</Modal.Title>
    </Modal.Header>
    <Modal.Body className="text-center">
      <h1>
        <img
          src={UofTLogo}
          className="client-logo"
          height="34"
          alt="University of Toronto Logo"
        />
      </h1>
      <p className="larger no-bold">
        The contents of Identify, Assist, Refer are intended for
        informational and educational use at the University of Toronto. For
        emergency situations, please refer to the University of Toronto’s Safety
        & Support resources.
      </p>
      <p className="larger no-bold">
        You will be redirected in <span className="countdown">{time}</span> seconds
        to{' '}
        <a href="http://safety.utoronto.ca/" target="_blank">
          http://safety.utoronto.ca
        </a>.
      </p>
    </Modal.Body>
    <Modal.Footer />
  </Modal>
);

MyModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export default MyModal;



// WEBPACK FOOTER //
// ./src/containers/Modal/index.jsx